
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import placeIndex from '@/components/placeOrder/placeIndex' //下单
import Personalindex from '@/components/PersonalCenter/Personalindex' //个人中心
import userCountshow from '@/components/PersonalCenter/userCountshow' //个人中心首页展示
import BulkOrderbysea from '@/components/PersonalCenter/BulkOrder/BulkOrderbysea' //海运散货
import OrderDetails from '@/components/PersonalCenter/BulkOrder/OrderDetails' //海运散货查看详情
import Mybill from '@/components/PersonalCenter/billType/Mybill' //我的账单
import tabelTest from '@/components/PersonalCenter/billType/tabelTest' //我的账单
import PayDetail from '@/components/PersonalCenter/billType/PayDetail' //我的账单
import PayOrder from '@/components/PersonalCenter/billType/PayOrder' //支付
import PayRecord from '@/components/PersonalCenter/billType/PayRecord' //我的账单
import UserManage from '@/components/PersonalCenter/accountManage/UserManage' //用户管理
import SubaccountManage from '@/components/PersonalCenter/accountManage/SubaccountManage' //子账号管理
import ManagementRole from '@/components/PersonalCenter/accountManage/ManagementRole'//角色管理
import PermissionAssignment from '@/components/PersonalCenter/accountManage/PermissionAssignment'//查看权限，分配权限
// 个人中心

import ReceivePage from '@/components/PersonalCenter/personalInfo/ReceivePage' //收件人
import PickPage from '@/components/PersonalCenter/personalInfo/PickPage' //提货人
import SendPage from '@/components/PersonalCenter/personalInfo/SendPage' //发货人
import TrackSetting from '@/components/PersonalCenter/personalInfo/TrackSetting' //轨迹设置
// import ReceivePage from '@/components/PersonalCenter/personalInfo/ReceivePage' //用户管理
import bulkCargo from '@/components/placeOrder/bulkCargo' //下单第一页
// import userArrdata from '@/components/placeOrder/userArrdata' //地址薄 弹窗组件
import newservice from '@/components/placeOrder/newservice' //增值服务
import Consignment from '@/components/placeOrder/Consignment' //托运信息
import Qdbill from '@/components/placeOrder/Qdbill' //确认托运
import orderSuccess from '@/components/placeOrder/orderSuccess' //委托完成

import buikAllbox from '@/components/PersonalCenter/buikAllbox/buikAllbox' //海运整柜
import AirOrder from '@/components/PersonalCenter/AirOrder/AirOrder' //空运
import AirOrderDetail from '@/components/PersonalCenter/AirOrder/AirOrderDetail' //空运

import Smallbag from '@/components/PersonalCenter/Smallbag/Smallbag' //跨境小包
// import FBAheader from '@/components/PersonalCenter/FBAheader/FBAheader' //fba ？？？？
// import FbaOrderDetails from '@/components/PersonalCenter/FBAheader/FbaOrderDetails' //fba ？？？？
import newBulkCargo from '@/components/placeOrder/newBulkCargo' // 散货下单
import fastBulkCargo from '@/components/placeOrder/fastBulkCargo' // 散货超卖
import getBulkWarehouseNo from '@/components/placeOrder/getBulkWarehouseNo' // 散货入仓号
import editBulkOrder from '@/components/placeOrder/editBulkOrder'


import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// FBA
import FbaCargo from '@/components/FBAorder/FbaCargo' //下单第一页
import Fbaservice from '@/components/FBAorder/Fbaservice' //FBA增值服务
import Fbaconsignment from '@/components/FBAorder/Fbaconsignment' //FBA托运信息
import Fbaqdbill from '@/components/FBAorder/Fbaqdbill' //FBA确认委托
import FbaorderSuccess from '@/components/FBAorder/FbaorderSuccess' //FBA委托完成
import FBAheader from '@/components/PersonalCenter/FBAheader/FBAheader' //FBA委托完成
import FbaOrderDetails from '@/components/PersonalCenter/FBAheader/FbaOrderDetails' //FBA委托完成
import Classify from '@/components/PersonalCenter/personalInfo/Classify' //商品分类
import FbaGoodsBase from '@/components/PersonalCenter/FBAheader/FbaGoodsBase' //FBA商品基本信息
import FbnAppointment from '@/components/PersonalCenter/FBAheader/FbnAppointment' //FBN约仓管理
// 空运
import newAirOrders from '@/components/airOrder/newAirOrders'  // 空运下单
import getAirWarehouseNo from '@/components/airOrder/getAirWarehouseNo' // 获取空运入仓号
import fastAirOrder from '@/components/airOrder/fastAirOrder' // 空运超卖下单
import editAirOrder from '@/components/airOrder/editAirOrder' // 空运订单编辑
import AirCargoIndex from '@/components/airOrder/AirCargoIndex' //下单第一页
import AirMoreService from '@/components/airOrder/AirMoreService' //增值服务
import AirConsignment from '@/components/airOrder/AirConsignment' //托运信息
import AirConfirmPage from '@/components/airOrder/AirConfirmPage' //确认托运
import AirOrderSuccess from '@/components/airOrder/AirOrderSuccess' //委托完成
//SEND
import SellerWarehouseDataConfirm from '@/components/SEND/SellerWarehouseDataConfirm' //SEND卖家入仓数据确认

// 整柜入仓单 
import fullWareReceipt from '@/components/goodsValue/fullWareReceipt'
// 散货入仓单
import warehouseReceipt from '@/components/goodsValue/warehouseReceipt'

// 运输协议
import serviceAgreement from '../../common/serviceAgreement.vue'

NProgress.configure({ showSpinner: false }) // 配置NProgress

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



Vue.use(Router)
const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '', // 首页
          component: placeIndex,
          name: 'placeIndex'
        }
      ]
    },
    {
      path: '/SEND/SellerWarehouseDataConfirm',
      name: 'SellerWarehouseDataConfirm',
      component: SellerWarehouseDataConfirm
    },
    {
      path: '/serviceAgreement',
      name: 'serviceAgreement',
      component: serviceAgreement
    },
    {
      path: '/goodsValue/fullWareReceipt',
      name: 'fullWareReceipt',
      component: fullWareReceipt
    },
    {
      path: '/goodsValue/warehouseReceipt',
      name: 'warehouseReceipt',
      component: warehouseReceipt
    },
    {
      path: '/index',
      name: 'index',
      component: Index,

      children: [
        {
          path: 'placeOrder/placeIndex', // 旧首页路径，重定向到根路径
          redirect: '/'
        },
        // {
        //   path: 'placeOrder/bulkCargo', //下单第一页
        //   name: 'bulkCargo',
        //   component: bulkCargo,
        // },
        {
          path: 'placeOrder/newBulkCargo', // 散货下单
          name: 'newBulkCargo',
          component: newBulkCargo
        },
        // {
        //   path: 'placeOrder/getBulkWarehouseNo', // 散货快捷拿入仓号
        //   name: 'getBulkWarehouseNo',
        //   component: getBulkWarehouseNo
        // },
        // {
        //   path: 'placeOrder/fastBulkCargo', // 散货超卖下单
        //   name: 'fastBulkCargo',
        //   component: fastBulkCargo
        // },
        {
          path: 'palceOrder/editBulkOrder', // 散货补料
          name: 'editBulkOrder',
          component: editBulkOrder
        },
        {
          path: 'placeOrder/newservice', //增值服务
          name: 'newservice',
          component: newservice,
        },
        {
          path: 'placeOrder/Consignment', //增值服务
          name: 'Consignment',
          component: Consignment,
        },
        {
          path: 'placeOrder/Qdbill', //确认委托
          name: 'Qdbill',
          component: Qdbill,
        },
        {
          path: 'Personalindex/payOrder', //支付
          component: PayOrder,
          name: 'payOrder',

        },
        {
          path: 'Personalindex/orderSuccess', //完成委托
          component: orderSuccess,
          name: 'orderSuccess',

        },
        {
          path: 'FBAorder/FbaCargo',//fba  下单第一页
          component: FbaCargo,
          name: 'FbaCargo',

        },
        {
          path: 'FBAorder/Fbaservice',//fba增值服务
          component: Fbaservice,
          name: 'Fbaservice',
        },
        {
          path: 'FBAorder/Fbaconsignment',//fba托运信息
          component: Fbaconsignment,
          name: 'Fbaconsignment',
        },
        {
          path: 'FBAorder/Fbaqdbill',//fba确认委托
          component: Fbaqdbill,
          name: 'Fbaqdbill',
        },
        {
          path: 'FBAorder/FbaorderSuccess',//fba 委托完成
          component: FbaorderSuccess,
          name: 'FbaorderSuccess',
        },

        // 空运
        {
          path: 'airOrder/newAirOrders', // 空运下单
          component: newAirOrders,
          name: 'newAirOrders'
        },
        // {
        //   path: 'airOrder/getAirWarehouseNo', // 空运快速获取入仓号
        //   component: getAirWarehouseNo,
        //   name: 'getAirWarehouseNo'
        // },
        // {
        //   path: 'airOrder/fastAirOrder', // 空运超卖下单
        //   component: fastAirOrder,
        //   name: 'fastAirOrder'
        // },
        {
          path: 'airOrder/editAirOrder', // 空运编辑订单
          component: editAirOrder,
          name: 'editAirOrder'
        },
        {
          path: 'airOrder/AirCargoIndex',//  下单第一页
          component: AirCargoIndex,
          name: 'AirCargoIndex',

        },
        {
          path: 'airOrder/AirMoreService',//增值服务
          component: AirMoreService,
          name: 'AirMoreService',
        },
        {
          path: 'airOrder/AirConsignment',//托运信息
          component: AirConsignment,
          name: 'AirConsignment',
        },
        {
          path: 'airOrder/AirConfirmPage',//确认委托
          component: AirConfirmPage,
          name: 'AirConfirmPage',
        },
        {
          path: 'airOrder/AirOrderSuccess',// 委托完成
          component: AirOrderSuccess,
          name: 'AirOrderSuccess',
        },

        {
          path: 'PersonalCenter/Personalindex', //个人中心首页默认空页面
          name: 'Personalindex',
          component: Personalindex,
          children: [
            {
              path: 'PersonalCenter/BulkOrder/BulkOrderbysea', //海运散货
              name: 'BulkOrderbysea',
              component: BulkOrderbysea,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/userCountshow', //个人中心首页展示
              component: userCountshow,
              name: 'userCountshow',
              meta: { title: true }

            },
            {
              path: 'PersonalCenter/BulkOrder/BulkOrderbysea/OrderDetails', //海运散货查看详情
              name: 'OrderDetails',
              component: OrderDetails,
            },
            {
              path: 'PersonalCenter/billType/Mybill', //我的账单
              name: 'Mybill',
              component: Mybill,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/billType/PayDetail', //支付详情
              name: 'PayDetail',
              component: PayDetail,
            },
            {
              path: 'PersonalCenter/billType/PayRecord', //我的账单
              name: 'PayRecord',
              component: PayRecord,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/UserManage', ////用户管理
              name: 'UserManage',
              component: UserManage,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/SubaccountManage', ////子账号管理
              name: 'SubaccountManage',
              component: SubaccountManage,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/ManagementRole', //角色管理
              name: 'ManagementRole',
              component: ManagementRole,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/accountManage/PermissionAssignment', //角色管理,查看权限，分配权限
              name: 'PermissionAssignment',
              component: PermissionAssignment,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/Classify', ////商品分类
              name: 'Classify',
              component: Classify,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/FbaGoodsBase', //商品基本信息
              name: 'FbaGoodsBase',
              component: FbaGoodsBase,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/FbnAppointment', //fbn约仓管理
              name: 'FbnAppointment',
              component: FbnAppointment,
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/personalInfo/ReceivePage', ////收货人
              name: 'ReceivePage',
              component: ReceivePage,
              meta: { title: true }
            },

            {
              path: 'PersonalCenter/personalInfo/PickPage', ////提货人
              name: 'PickPage',
              component: PickPage,
              meta: { title: true }
            },

            {
              path: 'PersonalCenter/personalInfo/SendPage', ////发货人
              name: 'SendPage',
              component: SendPage,
              meta: { title: true }
            }
            ,

            {
              path: 'PersonalCenter/personalInfo/TrackSetting', ////轨迹
              name: 'TrackSetting',
              component: () => import('@/components/PersonalCenter/personalInfo/TrackSetting'),
              meta: { title: true }
            },
            {
              path: 'PersonalCenter/buikAllbox/buikAllbox', //海运整柜
              component: buikAllbox,
              name: 'buikAllbox',
              meta: { title: true }

            },
            {

              path: 'PersonalCenter/AirOrder/AirOrder', //空运
              component: AirOrder,
              name: 'AirOrder',
              meta: { title: true }

            },
            {

              path: 'PersonalCenter/AirOrder/AirOrderDetail', //空运详情
              component: AirOrderDetail,
              name: 'AirOrderDetail',
              meta: { title: true }

            },

            {
              path: 'PersonalCenter/FBAheader/FBAheader', //Fba头程
              component: FBAheader,
              name: 'FBAheader',
              meta: { title: true }

            },
            ,
            {
              path: 'PersonalCenter/FBAheader/FbaOrderDetails', //FBA订单详情
              component: FbaOrderDetails,
              name: 'FbaOrderDetails',
              meta: { title: true }

            },

            {
              path: 'PersonalCenter/Smallbag/Smallbag', //跨境小包
              component: Smallbag,
              name: 'Smallbag',
              meta: { title: true }

            },
            {
              path: 'PersonalCenter/getAirWarehouseNo', // 空运快速获取入仓号
              component: getAirWarehouseNo,
              name: 'getAirWarehouseNo'
            },
            {
              path: 'PersonalCenter/fastAirOrder', // 空运超卖下单
              component: fastAirOrder,
              name: 'fastAirOrder'
            },
            {
              path: 'PersonalCenter/getBulkWarehouseNo', // 散货快捷拿入仓号
              name: 'getBulkWarehouseNo',
              component: getBulkWarehouseNo
            },
            {
              path: 'PersonalCenter/fastBulkCargo', // 散货超卖下单
              name: 'fastBulkCargo',
              component: fastBulkCargo
            },
          ]
        }
      ]
    }
  ],


})

//挂载路由导航守卫
router.beforeEach((to, from, next) => {
  let whiteList = ['/', '/index/placeOrder/placeIndex',
    '/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow'
  ]
  NProgress.start()
  //  next() 放行    next('/login') 强制跳转
  // console.log('to-----')
  // console.log(to)
  // console.log('from-----')
  // console.log(from)

  // 如果为true为需要鉴权的网页
  // if(to.meta.title){
  //          // console.log('meta1');
  //         let authorities = window.sessionStorage.getItem('authList')
  //         authorities = JSON.parse(authorities)
  //         authorities = [...authorities,...whiteList]
  //         // 如果此路由包含在内就通过
  //             if(authorities.includes(to.path)){
  //               next()
  //             }else{
  //               alert('无权访问')
  //             }
  //   // 不需要鉴权直接过
  // }else{
  next()
  // }



})
router.afterEach(() => {
  NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js